module.exports = __webpack_public_path__ + "img/symphony_560_steel.6a5c26c5.jpg";